/* eslint-disable consistent-return */
import { defineStore } from 'pinia';
import axios from '@/axios';
import { $settings } from '@/provider/settings';
import { useRootStore } from '@/store/root';
import { orderBy, deepGet, deepClone } from '@/helper/lodashHelper';

const sapUrl = $settings.middlewareSAPProxyURI;

const translateKeys = function (keyString, payload) {
  let keys = '';
  if (/%(.*?)%/gi.test(keyString)) {
    keys = keyString.match(/%(.*?)%/gi);
  } else {
    return keyString;
  }
  let translatedKeys = keyString;

  keys.forEach((key) => {
    const plainKey = key.replaceAll('%', '') || [];
    let value = deepGet(payload, plainKey) || '';

    if (value.includes('&')) {
      value = encodeURIComponent(value);
    }
    translatedKeys = translatedKeys.replace(key, value);
  });

  return translatedKeys;
};

export const useContextLinksStore = defineStore('contextlinks', {
  state: () => ({
    contextLinks: {},
  }),
  getters: {
    getContextLinks: (state) => (config) => {
      const { contextLinks = {} } = state;
      const { type, subType, buttonType, payload, filter } = config;
      const contextLinksFromModules =
        contextLinks[subType] || contextLinks[type];
      const contextLinksSorted = orderBy(
        (contextLinksFromModules && contextLinksFromModules[buttonType]) || [],
        'position',
      );
      let addLineItemFiltered = false;

      return contextLinksSorted
        .filter((item) => {
          if (
            filter !== false &&
            item.method === 'add_line' &&
            !addLineItemFiltered
          ) {
            addLineItemFiltered = true;
            return false;
          }
          return true;
        })
        .map((item) => {
          const resultItem = deepClone(item);
          const hasTranslationKeys = [
            'external',
            'internal',
            'sendLink',
          ].includes(item.method);

          if (hasTranslationKeys)
            resultItem.param = translateKeys(item.param || [], payload);

          return resultItem;
        });
    },
  },
  actions: {
    setContextLinks({ type, contextLinks }) {
      this.contextLinks[type] = { ...contextLinks };
    },
    // TODO: Only works on site based pinned items. Pinned items on e.g. overview items is not supported yet
    async initToggledItems({ type, buttonType }) {
      const { type: parentType, key } = useRootStore().parentObject;
      const contextLinks = this.contextLinks[type]
        ? this.contextLinks[type][buttonType]
        : [];
      if (!key) return false;
      if (!Array.isArray(contextLinks)) return false;

      contextLinks.forEach(({ param }) => {
        if (param && param.search) {
          const isToggle = param.search('toggle/') !== -1;

          if (isToggle) {
            const [, action] = param.split('/') || [];

            this.toggleStatus({
              type: parentType,
              action,
              buttonType,
              objKey: key,
            });
          }
        }
      });

      return true;
    },
    async toggleStatus({ type, buttonType, action, objKey, method = 'get' }) {
      return axios({
        method,
        url: `${sapUrl}/${type}/toggle/${action}/${objKey}`,
      }).then((response) => {
        const { state } = response.data;

        this.contextLinks[type] &&
          this.contextLinks[type][buttonType] &&
          this.contextLinks[type][buttonType].map((contextLink) => {
            if (contextLink.param === `toggle/${action}`)
              contextLink.state = state;

            return contextLink;
          });
      });
    },
  },
});
